import * as React from 'react'
// components
import ObjectivesList from 'containers/ObjectivesList/MemoizedContainer'
// context
import ObjectivesListAPI from 'containers/ObjectivesList/layers/API/index'
import ObjectivesListLinkingBL from './layers/BL/Linking'
import ObjectivesListNavigationBL from './layers/BL/Navigation'
import ObjectivesListTreeBL from './layers/BL/Tree'
// types
import { IPlan } from 'types/graphql'

// types
interface Props {
  plan: IPlan
}

const ObjectivesListContainer: React.FC<Props> = ({ plan }) => {
  return (
    <ObjectivesListAPI plan={plan}>
      <ObjectivesListLinkingBL>
        <ObjectivesListNavigationBL>
          <ObjectivesListTreeBL plan={plan}>
            <ObjectivesList />
          </ObjectivesListTreeBL>
        </ObjectivesListNavigationBL>
      </ObjectivesListLinkingBL>
    </ObjectivesListAPI>
  )
}

export default ObjectivesListContainer
